// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__30IAs","subheader":"ReorderModal_subheader__3vyk7","listWrap":"ReorderModal_listWrap__2t8xS"};